//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherCalendarDisplayItem } from './TeacherCalendarDisplayItem';
import { EventColorEnum } from './Enums';

export class ExternalEventDisplayItem extends ItemBase {
    ID: string | null = null;
    ExternalID: string | null = null;
    TeacherID: string | null = null;
    FeedID: string | null = null;
    FeedName: string | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    Teacher: TeacherCalendarDisplayItem | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    Description: string | null = null;
    Busy: boolean = false;
    AllDay: boolean = false;

    constructor(initializer?: Partial<ExternalEventDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ExternalEventDisplayItem";
}
